// extracted by mini-css-extract-plugin
export default {"container":"LearnWin_container__3phnZ","heading":"LearnWin_heading__X6lYB","subheading":"LearnWin_subheading__0Pu5O","grid":"LearnWin_grid__Q79hJ","card":"LearnWin_card__IV+ES"};